import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import BentoWidgetCard, { WidgetQuestion } from '../BentoWidgetCard';
import { getFunnelData } from '../../../../utils/aiBriefingsData';
interface FunnelEcosistemaWidgetProps {
  onExpand?: () => void;
  onHide?: () => void;
  onAsk?: (question: string) => void;
}
const FunnelEcosistemaWidget: React.FC<FunnelEcosistemaWidgetProps> = ({
  onExpand,
  onHide,
  onAsk
}) => {
  const data = getFunnelData();
  const questions: WidgetQuestion[] = [{
    id: '1',
    text: 'Dove perdiamo più utenti?'
  }, {
    id: '2',
    text: 'Come migliorare la conversione?'
  }, {
    id: '3',
    text: 'Confronta con benchmark'
  }];
  const colors = ['#3B82F6', '#60A5FA', '#93C5FD', '#BFDBFE', '#DBEAFE', '#EFF6FF', '#F0F9FF'];
  return <BentoWidgetCard id="funnel-ecosistema" title="Funnel Ecosistema" size="L" lastUpdated="10 min fa" questions={questions} onExpand={onExpand} onHide={onHide} onAsk={onAsk} data-id="element-1427">
      <div className="h-64" data-id="element-1428">
        <ResponsiveContainer width="100%" height="100%" data-id="element-1429">
          <BarChart data={data} layout="vertical" data-id="element-1430">
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" data-id="element-1431" />
            <XAxis type="number" stroke="#6B7280" fontSize={11} data-id="element-1432" />
            <YAxis type="category" dataKey="label" stroke="#6B7280" fontSize={11} width={120} data-id="element-1433" />
            <Tooltip contentStyle={{
            backgroundColor: '#FFFFFF',
            border: '1px solid #E5E7EB',
            borderRadius: '0.5rem',
            fontSize: '12px'
          }} formatter={(value: any, name: any, props: any) => [`${value.toLocaleString()} utenti (${props.payload.dropoff ? `-${props.payload.dropoff}%` : '0%'})`, 'Utenti']} data-id="element-1434" />
            <Bar dataKey="value" radius={[0, 4, 4, 0]} data-id="element-1435">
              {data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index % colors.length]} data-id="element-1436" />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-2 gap-3 mt-4" data-id="element-1437">
        {data.map((step, index) => <div key={index} className="bg-gray-50 rounded-lg p-2" data-id="element-1438">
            <p className="text-xs text-gray-600" data-id="element-1439">{step.label}</p>
            <p className="text-sm font-bold text-gray-900" data-id="element-1440">
              {step.value.toLocaleString()}
            </p>
            {step.dropoff !== undefined && step.dropoff > 0 && <p className="text-xs text-red-600" data-id="element-1441">-{step.dropoff}% drop-off</p>}
          </div>)}
      </div>
    </BentoWidgetCard>;
};
export default FunnelEcosistemaWidget;